// SPDX-FileCopyrightText: 2024-2025 John Livingston <https://www.john-livingston.fr/>
//
// SPDX-License-Identifier: AGPL-3.0-only

export const XMLNS_NOTE = 'urn:peertube-plugin-livechat:note'
